// extracted by mini-css-extract-plugin
export var actionButton = "_9c-1";
export var actionButtons = "_9c-2";
export var actions = "_9c-0";
export var aiUnread = "_9c-10";
export var alignCenter = "_9c-h";
export var backWrapper = "_9c-3";
export var cellContainer = "_9c-4";
export var checkboxContainer = "_9c-5";
export var contentContainer = "_9c-6";
export var contentHeader = "_9c-8";
export var conversationsTableWrapper = "_9c-s";
export var draftReplyBadgeContainer = "_9c-m";
export var dropdownItem = "_9c-b";
export var dropdownItemsContainer = "_9c-a";
export var dropdownTitle = "_9c-c";
export var errorIcon = "_9c-7";
export var filter = "_9c-d";
export var gray = "_9c-i";
export var headerActionButtons = "_9c-e";
export var headerCheckboxContainer = "_9c-f";
export var icon = "_9c-j";
export var menuContainer = "_9c-k";
export var noMoreTicketsIcon = "_9c-12";
export var noMoreTicketsSubText = "_9c-13";
export var oneLine = "_9c-l";
export var optionsButton = "_9c-n";
export var plus = "_9c-o";
export var portalButtonsWrapper = "_9c-g";
export var red = "_9c-p";
export var scrolledTop = "_9c-9";
export var search = "_9c-q";
export var selectedConversationsCount = "_9c-r";
export var spinner = "_9c-t";
export var strong = "_9c-u";
export var summaryCell = "_9c-v";
export var tableContainer = "_9c-11";
export var tagContainer = "_9c-w";
export var threeDots = "_9c-x";
export var twoLines = "_9c-y";
export var unread = "_9c-z";